















import { Component, Vue, Prop } from 'vue-property-decorator'
import VueSlider from '../../lib/'

@Component({})
export default class ExampleData extends Vue {

  scope = { VueSlider }

  @Prop({ required: true })
  value!: string

  switchCodeShow() {
    const el = (this.$refs.content as HTMLDivElement).querySelector('.vuep-editor')
    if (el) {
      el.classList.toggle('show')
    }
  }
}
